import "./CheckoutPage.scss";

import { Container, Row } from "@amzn/stencil-react-components/layout";
import CheckoutFormPanel from "common/components/CheckoutFormPanel/CheckoutFormPanel";
import CheckoutItemSidePanel from "common/components/CheckoutItemSidePanel/CheckoutItemSidePanel";
import { useMessageBannersBox } from "common/components/MessageBannersBox/hook";
import { getString } from "common/uistringlabels/uiStringUtils";
import { PERMISSIONS } from "config";
import { UserPermissions } from "lib/services";
import { IItemVersion, ItemDetails } from "lib/types/items";
import React, { FC, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { useChangeAddressForm } from "./useChangeAddressForm";
import { useCheckoutForm } from "./useCheckoutForm";

export interface CheckoutState {
  versions: IItemVersion[];
  defaultVersion: IItemVersion;
  parentName?: string;
  parentTxId?: string;
}

export interface CatalogItemVersion {
  id?: string;
  price?: number;
  recurrence?: any;
  currency?: string;
  name?: string;
  shortDescription?: string;
}

const CheckoutPage: FC = () => {
  const location = useLocation();
  const history = useHistory();

  const { addErrorBanner } = useMessageBannersBox();
  const [hasItemInfo, setHasItemInfo] = useState<boolean | undefined>(undefined);

  const localState: CheckoutState | undefined = location.state as CheckoutState;

  const { items: addressFormItems, actions: addressFormActions } = useChangeAddressForm();
  const { items: checkoutFormItems, actions: checkoutFormActions } = useCheckoutForm();

  useEffect(() => {
    if (localState === undefined || !localState.defaultVersion || !localState.versions) {
      setHasItemInfo(false);
    } else {
      checkoutFormActions.handleInputChange("catalogItemVersion", localState.defaultVersion);
      setHasItemInfo(true);
    }
  }, []);

  if (hasItemInfo === undefined) {
    return <></>;
  }

  // Redirect to homepage
  if (hasItemInfo === false) {
    history.push("/");
    return null;
  }

  if (!UserPermissions.current.hasPermission(PERMISSIONS.USE_HARDWARE_SHOP)) {
    addErrorBanner(getString("errors.notAuthorized"), false);
    history.push("/");
  }

  return (
    <Container isFullWidth={true}>
      <Row>
        {/* CheckoutSidePanel */}
        <CheckoutItemSidePanel
          checkoutItems={checkoutFormItems}
          checkoutActions={checkoutFormActions}
          options={localState.versions}
          parentItemName={localState.parentName}
        />

        {/* CheckoutFormPanel */}
        <CheckoutFormPanel
          checkoutItems={checkoutFormItems}
          checkoutActions={checkoutFormActions}
          addressItems={addressFormItems}
          addressActions={addressFormActions}
          pdpItemTaxonomyId={localState.parentTxId}
        />
      </Row>
    </Container>
  );
};

export default CheckoutPage;
